import script from "./RepaymentTermSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RepaymentTermSelection.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/professional-grad/button.css?vue&type=style&index=0&id=13b921a6&scoped=true&lang=css"
import "@/styles/professional-grad/substep.css?vue&type=style&index=1&id=13b921a6&scoped=true&lang=css"
import "@/styles/professional-grad/substep-3.css?vue&type=style&index=2&id=13b921a6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b921a6"]])

export default __exports__